import {AnimeInstance} from 'animejs';

import {easing} from '@helpers/easing';
import {MediaQuery} from '@services/MediaQuery';

export class TextAnimation {
  private mq = MediaQuery.create();
  private showAnime: AnimeInstance | null = null;

  constructor(private element: HTMLDivElement) {}

  // FIXME: クソコード
  private removeBr() {
    const children = [...(this.element.childNodes as NodeListOf<HTMLElement>)];
    const filtered = children.filter((child) => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        if (this.mq.isDesktop() && child.classList.contains('hidden-desktop')) {
          return false;
        }
        if (this.mq.isPhone() && child.classList.contains('hidden-phone')) {
          return false;
        }
      }
      return child;
    });
    this.element.innerHTML = '';
    let text = '';
    filtered.map((a, index) => {
      const isLast = filtered.length - 1 === index;
      if (a.nodeType === Node.TEXT_NODE) {
        text += a.textContent;
        if (isLast) {
          this.element.append(text);
        }
      } else {
        this.element.append(text);
        text = '';
        this.element.appendChild(a);
      }
    });
    return [...(this.element.childNodes as NodeListOf<HTMLElement>)];
  }

  public init(crop = false) {
    const children = this.removeBr();
    const {height} = this.element.getBoundingClientRect();
    let textCount = 0;
    let fontStyle = '';
    if (crop) {
      const {
        fontSize,
        lineHeight = 0,
        letterSpacing,
      } = window.getComputedStyle(this.element);
      this.element.style.lineHeight = 'inherit';
      this.element.style.fontSize = 'inherit';
      this.element.style.letterSpacing = 'inherit';
      fontStyle = `letter-spacing: ${letterSpacing}; line-height: ${lineHeight}; font-size: ${fontSize};`;
    }
    this.element.innerHTML = children
      .map((child) => {
        const isText = child.nodeType === Node.TEXT_NODE;
        if (isText) {
          textCount++;
          const textContent = child.textContent?.trim() || '';
          const ret = textContent.split('').reduce((acc, val) => {
            const isBlank = val === ' ';
            return (
              acc +
              `<span class="char" style="${fontStyle}; position: relative; left: -0.05em; top: -0.075em; padding-bottom: 0.11em; display: inline-block; transform: translateY(${
                height * 1.5
              }px); ${isBlank && 'min-width: 0.3em'}">${val}</span>`
            );
            // return acc + `<span class="char" style="${fontStyle}; position: relative; left: -0.05em; top: -0.11em; display: inline-block; transform: translateY(${height * 1.5}px); ${isBlank && 'min-width: 0.3em'}">${val}</span>`
          }, '');
          // const margin = textCount > 1 ? 'margin-top: -0.4em' : ''
          const margin = textCount > 1 ? '' : '';
          return `<span class="char-row" style="margin-bottom: -0.085em; width: 101%; display: inline-block;overflow:hidden; ${margin}">${ret}</span>`;
        } else {
          return child.outerHTML;
        }
      })
      .join('');
  }

  public show() {
    const targets = [
      ...this.element.querySelectorAll('.char'),
    ] as HTMLSpanElement[];
    targets.map((target, index) => {
      const delay = Math.min(20 / (targets.length / 20), 20) * index;
      target.style.transition = `transform 0.8s ${easing.easeOutCubic} ${delay}ms`;
      target.style.transform = 'translateY(0px)';
    });
    // this.showAnime = anime({
    //   duration: 800,
    //   easing: 'easeOutCubic',
    //   targets,
    //   delay: anime.stagger(Math.min(20 / (targets.length / 20), 20)),
    //   translateY: '0px',
    // })
  }

  public hide() {
    this.showAnime?.pause();
    const {height} = this.element.getBoundingClientRect();
    const targets = [
      ...this.element.querySelectorAll('.char'),
    ] as HTMLSpanElement[];
    targets.map((target) => {
      target.style.transition = '';
      target.style.transform = `translateY(${height * 1.5}px)`;
    });
    // anime({
    //   duration: 0,
    //   targets: this.element.querySelectorAll('.char'),
    //   translateY: `${height}px`,
    // })
  }
}
